import React from 'react'
import Question from './Question'
import RadioForm from '../form/RadioForm'
import SbitaForm from '../form/SbitaForm'
import InfoToggle from '../info/InfoToggle'
import ProgressBar from '../progress-bar/ProgressBar'
import SubmitForm from '../form/SubmitForm'
import SubmitSbitaForm from '../form/SubmitSbitaForm'

export default function PageTemplate({ formData, submitAnswer, submitForm }) {
	const {
		question,
		subQuestion,
		progress,
		navigation,
		info,
		answer,
		subAnswer,
	} = formData

	return (
		<>
			<div className='progress-Container'>
				<ProgressBar num={progress} />
			</div>
			{navigation && navigation.navSbitaTwo ? (
				<div className='page-Container'>
					<div className='column-Left'>
						<Question question={question} />
						<SbitaForm
							nav={navigation}
							promptNum={progress}
							submitAnswer={submitAnswer}
							subQuestion={subQuestion}
							value={answer ? answer : ''}
						/>
					</div>
					{info && (
						<div className='column-Right'>
							<InfoToggle info={info} />
						</div>
					)}
				</div>
			) : (
				<div className='page-Container'>
					<div className='column-Left'>
						<Question question={question} />
						{navigation ? (
							<RadioForm
								nav={navigation}
								promptNum={progress}
								submitAnswer={submitAnswer}
								subQuestion={subQuestion}
								subValue={subAnswer ? subAnswer : ''}
								value={answer ? answer : ''}
							/>
						) : window.location.pathname ===
						  '/gasb-96-SBITA-identifier/submit' ? (
							<SubmitSbitaForm submitForm={submitForm} />
						) : (
							<SubmitForm submitForm={submitForm} />
						)}
					</div>
					{info && (
						<div className='column-Right'>
							<InfoToggle info={info} />
						</div>
					)}
				</div>
			)}
		</>
	)
}
